import { render, staticRenderFns } from "./authorizationAudit.vue?vue&type=template&id=0bc4d5ae&"
import script from "./authorizationAudit.vue?vue&type=script&lang=js&"
export * from "./authorizationAudit.vue?vue&type=script&lang=js&"
import style0 from "./authorizationAudit.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "authorizationAudit.vue"
export default component.exports